import React from 'react';
import PropTypes from 'prop-types';

import { Card, Image, Table } from 'semantic-ui-react';
import { YoutubeIcon, InstagramIcon, TwitterIcon, FacebookIcon } from '../../components/dyzio-icons';

const STYLES = {
  smallFont: {
    fontSize: '80%',
  },
  displayBlock: {
    display: 'block',
  },
  noVerticalPadding: {
    padding: '0px 14px',
  },
};

const SmallCard = ({ influencer }) => (
  <Card key={influencer.id}>
    <Card.Content textAlign="center">
      <Card.Header style={STYLES.smallFont}>
        {influencer.name}
      </Card.Header>
    </Card.Content>
    <Card.Content>
      <Image
        src={influencer.thumbnail}
        size="tiny"
        centered
        shape="circular"
        style={STYLES.displayBlock}
      />
    </Card.Content>
    <Card.Content style={STYLES.noVerticalPadding}>
      <Table basic="very" singleLine compact textAlign="center">
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <YoutubeIcon />
            </Table.Cell>
            <Table.Cell>
              <InstagramIcon />
            </Table.Cell>
            <Table.Cell>
              <FacebookIcon />
            </Table.Cell>
            <Table.Cell>
              <TwitterIcon />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Card.Content>
  </Card>
);

SmallCard.propTypes = {
  influencer: PropTypes.object.isRequired,
};

export default SmallCard;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-influencers/small-card.js
 **/